import { useState } from 'react';
import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function HotGrid() {
  const hotComics = [...comics].sort((a, b) => b.popularity - a.popularity).slice(0, 10);
  const [visible, setVisible] = useState(8);
  const shown = hotComics.slice(0, visible);

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="mb-2 inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-fire-line"></i>
              热门榜单
            </span>
            <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">最受欢迎的双女主韩漫</h2>
            <p className="mt-1 text-sm text-foreground-500">
              根据阅读量与收藏热度实时更新，看看大家都在追什么
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-5 lg:grid-cols-4" data-product-shop>
          {shown.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        {visible < hotComics.length ? (
          <div className="mt-10 flex justify-center">
            <button
              type="button"
              onClick={() => setVisible(hotComics.length)}
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-8 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
            >
              <i className="ri-add-line"></i>
              加载更多热门漫画
            </button>
          </div>
        ) : (
          <div className="mt-10 flex justify-center">
            <Link
              to="/search"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-8 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-compass-3-line"></i>
              浏览全部漫画库
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}